import { notification } from 'antd'

import { EventServices } from '@/middlewares/services'
import { isSpotsAreUndefined } from '@/components/Registration/Steps/FillForm/index.utils'

export const ConvertToNumber = (value) => {
    const result = +(value || 0)
    if (isNaN(result)) return 0
    return result
}

export const resolveDivisionSpotsForDisplay = ({
    divisionSpots,
    competitionTotalSpots,
    divisionParticipantsCount = 0,
    competitionParticipantsCount = 0,
}) => {
    if (!isSpotsAreUndefined(divisionSpots)) {
        return {
            totalSpots: ConvertToNumber(divisionSpots),
            soldSpots: divisionParticipantsCount || 0,
        }
    }

    if (!isSpotsAreUndefined(competitionTotalSpots) && ConvertToNumber(competitionTotalSpots) > 0) {
        return {
            totalSpots: ConvertToNumber(competitionTotalSpots),
            soldSpots: competitionParticipantsCount || 0,
        }
    }

    return {
        totalSpots: 0,
        soldSpots: divisionParticipantsCount || 0,
    }
}

const isDivisionSpotsLimited = (spots) =>
    spots != null && spots !== '' && !Number.isNaN(Number(spots)) && Number(spots) > 0

const getDivisionSpotsCounts = (division) => {
    const soldSpots = ConvertToNumber(division.soldSpots ?? division.participants_count)
    const totalSpots = division.totalSpots

    if (isDivisionSpotsLimited(totalSpots)) {
        const total = ConvertToNumber(totalSpots)
        const left = Math.max(total - soldSpots, 0)
        return { type: 'limited', soldSpots, left, total }
    }

    if (soldSpots > 0) {
        return { type: 'unlimited', soldSpots }
    }

    return null
}

/** @deprecated Use getDivisionSpotsDisplay for split left/total styling. */
export const getDivisionSpotsLabel = (division, t, hideSpotsCount) => {
    if (hideSpotsCount) {
        return null
    }

    const counts = getDivisionSpotsCounts(division)
    if (!counts) {
        return null
    }

    if (counts.type === 'limited') {
        return t('spotsLeftOfTotal', { left: counts.left, total: counts.total })
    }

    return t('spotsSoldOfUnlimited', { sold: counts.soldSpots })
}

export const getDivisionSpotsDisplay = (division, t, hideSpotsCount) => {
    if (hideSpotsCount) {
        return null
    }

    const counts = getDivisionSpotsCounts(division)
    if (!counts) {
        return null
    }

    if (counts.type === 'limited') {
        return {
            type: 'limited',
            left: counts.left,
            total: counts.total,
            leftLabel: t('spotsLeftCount', { left: counts.left }),
            totalLabel: t('spotsTotalSuffix', { total: counts.total }),
        }
    }

    return {
        type: 'unlimited',
        label: t('spotsSoldOfUnlimited', { sold: counts.soldSpots }),
    }
}

export const ConvertLeaderboard = ({
    leaderboard,
    specific_division_price,
    specific_division_spots,
    planningIsPublished,
    ticketingIsPublished,
    ticketingDefault_price,
    volunteering,
}) => {
    const competitionTotalSpots = leaderboard?._ticketing?.total_spots
    const competitionParticipantsCount = leaderboard?.total_participants || 0

    return {
        ...leaderboard,
        divisions: leaderboard.divisions.map((o) => {
            const specific_division_price_found = specific_division_price.find(
                (b) => String(b.division_id) === String(o._id),
            )
            const specific_division_spots_found = specific_division_spots.find(
                (b) => String(b.division_id) === String(o._id),
            )

            const divisionPrice = specific_division_price_found?.division_price ?? (ticketingDefault_price || 0)

            o.price = ConvertToNumber(divisionPrice)

            const { totalSpots, soldSpots } = resolveDivisionSpotsForDisplay({
                divisionSpots: specific_division_spots_found?.division_spots,
                competitionTotalSpots,
                divisionParticipantsCount: o?.participants_count,
                competitionParticipantsCount,
            })
            o.totalSpots = totalSpots
            o.soldSpots = soldSpots

            return o
        }),
        planningIsPublished,
        ticketingIsPublished,
        volunteering: {
            ...volunteering,
        },
    }
}

const GetDivisionsTypes = (divisions) => {
    const hasSingle = divisions.some((o) => o.type == 'single')
    const hasTeam = divisions.some((o) => o.type == 'team')
    const types = []
    if (hasTeam) {
        types.push('TEAM')
    }
    if (hasSingle) {
        types.push('INDIV')
    }
    return types
}

export const ConvertPresentation = (presentation, leaderboard) => {
    return {
        ...presentation,
        tags: [...presentation.tags, ...GetDivisionsTypes(leaderboard.divisions)],
    }
}

export const handleDeletePartner = async (t, competitionId, partnerId, setIsLoading, setPresentation) => {
    try {
        console.log('/HandleDeletePartner -', partnerId)
        setIsLoading(true)
        const result = await EventServices.PartnerDelete(competitionId, partnerId)
        console.log('/HandleDeletePartner -', result)
        setPresentation(
            (previous) =>
                (previous = {
                    ...previous,
                    partners: previous.partners.filter((o) => o._id != partnerId),
                }),
        )
        notification.success({ message: t('Partner deleted successfully') })
        setIsLoading(false)
    } catch (error) {
        notification.error({
            message: t('Something went worng, Please try again later or contact us'),
        })
        setIsLoading(false)
    }
}
